import Axios from 'axios';
import Qs from 'qs';

export default {

  // 版本分页列表
  listPage(
    platform,
    terminal,
    page,
    limit
  ) {
    return Axios.get('/base/api/admin/version', {
      params: {
        filter: {
          platform,
          terminal
        },
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 添加版本
  add(
    version,
    platform,
    update_state,
    terminal,
    download_url,
    publish_time,
    description
  ) {
    return Axios.post('/base/api/admin/version', {
      version,
      platform,
      update_state,
      terminal,
      download_url,
      publish_time,
      description
    });
  },

  // 编辑版本
  edit(
    id,
    version,
    platform,
    update_state,
    terminal,
    download_url,
    publish_time,
    description
  ) {
    return Axios.patch(`/base/api/admin/version/${id}`, {
      version,
      platform,
      update_state,
      terminal,
      download_url,
      publish_time,
      description
    });
  },

  // 删除版本
  del(
    id
  ) {
    return Axios.delete(`/base/api/admin/version/${id}`);
  },

  // 版本信息
  info(
    id
  ) {
    return Axios.get(`/base/api/admin/version/${id}`);
  }

}